<template>
  <component :is="component"  v-if="component" />
</template>

<script>
export default {
  name: "TermsFilterLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    filterLayout: {},
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.filterLoader();
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.filterLayout) {
        return null
      }
      return () => import(`@/template/terms/filter/${this.filterLayout}`)
    },
  },
  methods:{
    filterLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/terms/filter/TermsFilterDefaultLayout')
          })
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>